<template>
    <div>
        <div v-if="!isUserLogged" class="footer-menu-div">
            <!--            <ul class="footer-menu">-->
            <!--                <li class="footer-menu__item">-->
            <!--                    <a :href="eSklepUrl + $t('LINK_BRASTER_FOR_HOME_USE')" class="footer-menu__link">{{-->
            <!--                        $t('BRASTER_FOR_HOME_USE')-->
            <!--                    }}</a>-->
            <!--                </li>-->
            <!--                <li class="footer-menu__item">-->
            <!--                    <a :href="eSklepUrl + $t('LINK_BRASTER_FOR_PROFESSIONAL_USE')" class="footer-menu__link">{{-->
            <!--                        $t('BRASTER_FOR_PROFESSIONAL_USE')-->
            <!--                    }}</a>-->
            <!--                </li>-->
            <!--            </ul>-->

            <!--            <ul class="footer-menu">-->
            <!--                <li class="footer-menu__item">-->
            <!--                    <a :href="eSklepUrl + $t('LINK_FIRMA_START')" class="footer-menu__link">{{-->
            <!--                        $t('ABOUT_COMPANY')-->
            <!--                    }}</a>-->
            <!--                </li>-->
            <!--                <li class="footer-menu__item">-->
            <!--                    <a :href="eSklepUrl + $t('LINK_OUR_MISSION')" class="footer-menu__link">{{ $t('OUR_MISSION') }}</a>-->
            <!--                </li>-->
            <!--            </ul>-->

            <!--            <ul class="footer-menu">-->
            <!--                <li class="footer-menu__item">-->
            <!--                    <a :href="eSklepUrl + $t('LINK_MANAGEMENT')" class="footer-menu__link">{{ $t('MANAGEMENT') }}</a>-->
            <!--                </li>-->
            <!--                <li class="footer-menu__item">-->
            <!--                    <a :href="eSklepUrl + $t('LINK_CONTACT')" class="footer-menu__link">{{ $t('CONTACT') }}</a>-->
            <!--                </li>-->
            <!--            </ul>-->

            <!--            <ul class="footer-menu">-->
            <!--                <li class="footer-menu__item">-->
            <!--                    <a :href="$t('LINK_RELACJE_INWESTORSKIE')" class="footer-menu__link">{{-->
            <!--                        $t('RELACJE_INWESTORSKIE')-->
            <!--                    }}</a>-->
            <!--                </li>-->
            <!--                <li class="footer-menu__item">-->
            <!--                    <a :href="eSklepUrl + $t('LINK_TERMS')" class="footer-menu__link">{{-->
            <!--                        $t('TERMS_AND_PRIVACY_POLICY')-->
            <!--                    }}</a>-->
            <!--                </li>-->
            <!--            </ul>-->
        </div>

        <div v-if="isUserLogged && accountTypeIsPro" class="footer-menu-div">
            <ul class="footer-menu">
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_WHAT_IS_BRASTER_PRO')" class="footer-menu__link">{{
                        $t('WHAT_IS_BRASTER_PRO')
                    }}</a>
                </li>
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_HOW_DOES_BRASTER_PRO_WORK')" class="footer-menu__link">{{
                        $t('HOW_DOES_BRASTER_PRO_WORK')
                    }}</a>
                </li>
            </ul>

            <ul class="footer-menu">
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_SKUTECZNOSC_PRO')" class="footer-menu__link">{{
                        $t('EFFICIENCY')
                    }}</a>
                </li>
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_CLINICAL_EXAMINATIONS')" class="footer-menu__link">{{
                        $t('CLINICAL_EXAMINATIONS')
                    }}</a>
                </li>
            </ul>

            <ul class="footer-menu">
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_FIRMA_PRO')" class="footer-menu__link">{{ $t('ABOUT_COMPANY') }}</a>
                </li>
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_CONTACT')" class="footer-menu__link">{{ $t('CONTACT') }}</a>
                </li>
            </ul>

            <ul class="footer-menu">
                <li class="footer-menu__item">
                    <a :href="$t('LINK_RELACJE_INWESTORSKIE')" class="footer-menu__link">{{
                        $t('RELACJE_INWESTORSKIE')
                    }}</a>
                </li>
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_TERMS')" class="footer-menu__link">{{
                        $t('TERMS_AND_PRIVACY_POLICY')
                    }}</a>
                </li>
            </ul>
        </div>

        <div v-if="isUserLogged && !accountTypeIsPro" class="footer-menu-div">
            <ul class="footer-menu">
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_CZYM_JEST_BRASTER')" class="footer-menu__link">{{
                        $t('ABOUT_BRASTER')
                    }}</a>
                </li>
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_JAK_DZIALA_BRASTER')" class="footer-menu__link">{{
                        $t('HOW_IT_WORKS')
                    }}</a>
                </li>
            </ul>

            <ul class="footer-menu">
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_SKUTECZNOSC')" class="footer-menu__link">{{ $t('EFFICIENCY') }}</a>
                </li>
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_PROFILAKTYKA')" class="footer-menu__link">{{ $t('PREVENTION') }}</a>
                </li>
            </ul>

            <ul class="footer-menu">
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_FIRMA')" class="footer-menu__link">{{ $t('ABOUT_COMPANY') }}</a>
                </li>
                <li class="footer-menu__item">
                    <a :href="userShopUrl" class="footer-menu__link">{{ $t('BUY_ONLINE') }}</a>
                </li>
            </ul>

            <ul class="footer-menu">
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_CONTACT')" class="footer-menu__link">{{ $t('CONTACT') }}</a>
                </li>
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_TO_FAQ')" class="footer-menu__link">{{ $t('FAQ') }}</a>
                </li>
            </ul>

            <ul class="footer-menu">
                <li class="footer-menu__item">
                    <a :href="$t('LINK_RELACJE_INWESTORSKIE')" class="footer-menu__link">{{
                        $t('RELACJE_INWESTORSKIE')
                    }}</a>
                </li>
                <li class="footer-menu__item">
                    <a :href="eSklepUrl + $t('LINK_TERMS')" class="footer-menu__link">{{
                        $t('TERMS_AND_PRIVACY_POLICY')
                    }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { config } from './../../../main';

export default {
    data() {
        return {
            lang: this.$store.state.interfaceLanguage,
            eSklepUrl: config.eSklepUrl,
        };
    },
    computed: {
        ...mapGetters(['userShopUrl', 'accountTypeIsPro']),
        isUserLogged() {
            return this.$store.state.isUserLogged;
        },
    },
};
</script>

<style lang="scss" scoped>
.footer-submenu__title {
    color: #fff;
    font-family: 'Mukta', sans-serif;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 14px;
    margin-top: 0;
}

.footer-list__item {
    display: block;
    font-size: 14px;
    margin: 0 0 10px;
    position: relative;
    padding-left: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.footer-list__item:before {
    content: '';
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 2.2px 0 2.2px 3.2px;
    border-color: transparent transparent transparent rgba(255, 255, 255, 0.4);
}

.footer-list__link {
    color: #fff;
    text-decoration: none;
}
</style>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// footer-menu.vue?de80efb6